// @flow
import loadGoogleMapsApi from 'load-google-maps-api';
import React from 'react';

import { GOOGLE_MAPS_API_KEY } from '../../settings';
import Input from '../Input';
import './geosearch.css';


type GeoSearchPropTypes = {
  onPlaceSelected?: Function,
  options?: Object
};

class GeoSearch extends React.Component<GeoSearchPropTypes> {
  componentDidMount() {
    // TODO: Probably needs to be inside an interval...
    if (this._input != null) {
      const { onPlaceSelected, options } = this.props;
      const googleSearchMountPoint = this._input.getInput();

      loadGoogleMapsApi({
        key: GOOGLE_MAPS_API_KEY,
        libraries: ['places'],
      }).then((maps) => {
        const autocomplete = new maps.places.Autocomplete(
          googleSearchMountPoint,
          options,
        );

        // Add select event
        autocomplete.addListener(
          'place_changed',
          () => {
            const place = autocomplete.getPlace();
            if (place.geometry && onPlaceSelected) {
              onPlaceSelected(place, autocomplete);
            }
          },
        );
      });
    }
  }

  _input: ?Input;

  render() {
    const newProps = { ...this.props };
    delete newProps.onPlaceSelected;

    return (
      <Input
        ref={(node) => { this._input = node; return node; }}
        {...newProps}
      />
    );
  }
}


export default GeoSearch;



// WEBPACK FOOTER //
// ./src/scripts/components/Geosearch/index.jsx